module.exports = __webpack_public_path__ + "static/media/final-parallax.4dbe2e7e.webp";